import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';
import BarChartContainer from './BarChartContainer';
import Pagination from './Pagination';
import { EllipsisBlock } from '../styled';

const AnalystLoadWidget = ({
  currentPage,
  itemsPerPage,
  items,
  axisLabel,
  legendLabel,
  legend,
  isSelectable,
  selectedItemId,
  onSelect,
  total,
  onPageChange
}) => {
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);

  const calculateTicks = () => {
    const res = currentItems.map(({ id, name, total, ...bar }) => {
      return Math.max(...Object.values(bar));
    });
    const maxTick = Math.max(...res) > 10 ? Math.max(...res) : 10;
    const ticksList = [
      maxTick,
      Math.round(maxTick * 0.75),
      Math.round(maxTick * 0.5),
      Math.round(maxTick * 0.25),
      0
    ];
    return ticksList;
  };

  const ticks = useMemo(() => calculateTicks(), [currentItems]);

  return (
    <Styled.MainContainerBox>
      <Styled.CustomFlexWrap>
        <Styled.BarMainGraph>
          <Styled.YAxisContainer>
            <Styled.YAxisContainerTitle>{axisLabel}</Styled.YAxisContainerTitle>
          </Styled.YAxisContainer>

          <Styled.MainBarContainer>
            <Styled.BarChartWrapper>
              <Styled.BarChartTimeCol>
                {ticks.map((tick, index) => {
                  return (
                    <Styled.BarChartTime key={index}>
                      <Styled.BarChartTimeText>{tick}</Styled.BarChartTimeText>
                    </Styled.BarChartTime>
                  );
                })}
              </Styled.BarChartTimeCol>

              <BarChartContainer
                legend={legend}
                isSelectable={isSelectable}
                selectedItemId={selectedItemId}
                onSelect={onSelect}
                currentItems={currentItems}
                highestTick={ticks[0]}
              />
            </Styled.BarChartWrapper>

            <Pagination
              total={total}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={onPageChange}
              showPageNo={
                items.length <= itemsPerPage ? false : true
              }></Pagination>
          </Styled.MainBarContainer>
        </Styled.BarMainGraph>

        <Styled.BarStatusBox>
          <div>
            <Styled.BarStatusTitle>{legendLabel}</Styled.BarStatusTitle>
            <Styled.BarStatusUL>
              {legend.map((item, key) => (
                <Styled.BarStatusLI key={key} color={item.color}>
                  <EllipsisBlock title={item.fieldName}>
                    {item.fieldName}
                  </EllipsisBlock>
                </Styled.BarStatusLI>
              ))}
            </Styled.BarStatusUL>
          </div>
        </Styled.BarStatusBox>
      </Styled.CustomFlexWrap>
    </Styled.MainContainerBox>
  );
};

AnalystLoadWidget.propTypes = {
  axisLabel: PropTypes.string.isRequired,
  legendLabel: PropTypes.string.isRequired,
  legend: PropTypes.arrayOf(
    PropTypes.shape({
      fieldKey: PropTypes.string.isRequired,
      fieldName: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired
    })
  ).isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  isSelectable: PropTypes.bool.isRequired,
  selectedItemId: PropTypes.number,
  onSelect: PropTypes.func,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func
};

export default AnalystLoadWidget;
